<template>
  <div>
    <SForm
      :url="url"
      :fields="fields"
      :dataForm="dataForm"
      :before="before"
      :handle="handle"
    ></SForm>
  </div>
</template>

<script>
export default {
  name: "TestForm",
  data() {
    return {
      url: "",
      dataForm: {
        idsa: [9, 10],
        text: "2",
      },
      fields: [
        {
          label: "文本框222",
          prop: "city",
          placeholder: "请输入",
          type: "city",
          rules: [
            {
              required: true,
              message: "请输入活动名称",
              trigger: "blur"
            },
            {
              min: 3,
              max: 5,
              message: "长度在 3 到 5 个字符",
              trigger: "blur"
            }
          ]
        },
        {
          label: "文本框",
          prop: "text",
          type: "radio",
          data: [
            {
              label: "A",
              value: "1"
            },
            {
              label: "B",
              value: "2"
            }
          ],
          placeholder: "请输入",
          rules: [
            {
              required: true,
              message: "请输入活动名称",
              trigger: "blur"
            },
            {
              min: 3,
              max: 5,
              message: "长度在 3 到 5 个字符",
              trigger: "blur"
            }
          ]
        },
        {
          label: "Tree",
          prop: "idsa",
          type: "tree",
          option: {
            data: [
              {
                id: 1,
                label: "一级 1",
                noData: true,
                children: [
                  {
                    id: 4,
                    label: "二级 1-1",
                    noData: true,
                    children: [
                      {
                        id: 9,
                        label: "三级 1-1-1"
                      },
                      {
                        id: 10,
                        label: "三级 1-1-2"
                      }
                    ]
                  }
                ]
              },
              {
                id: 2,
                label: "一级 2",
                noData: true,
                children: [
                  {
                    id: 5,
                    label: "二级 2-1"
                  },
                  {
                    id: 6,
                    label: "二级 2-2"
                  }
                ]
              },
              {
                id: 3,
                label: "一级 3",
                noData: true,
                children: [
                  {
                    id: 7,
                    label: "二级 3-1"
                  },
                  {
                    id: 8,
                    label: "二级 3-2"
                  }
                ]
              }
            ]
          }
        }
      ],
      handle: function(record) {
        alert(JSON.stringify(record));
      }
    };
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/TestForm.vue